import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Flag = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.712 18.288L18.412 11.001L25.699 3.71395C25.874 3.53895 25.987 3.28895 25.987 3.00195C25.987 2.45195 25.537 2.00195 24.987 2.00195H6.99902C6.44902 2.00195 5.99902 2.45195 5.99902 3.00195V29.002C5.99902 29.552 6.44902 30.002 6.99902 30.002C7.54902 30.002 7.99902 29.552 7.99902 29.002V20.002H24.999C25.549 20.002 25.999 19.552 25.999 19.002C25.999 18.727 25.886 18.477 25.711 18.29L25.712 18.288ZM8.00002 18V3.99995H22.587L16.299 10.287C16.124 10.462 16.011 10.712 16.011 11C16.011 11.288 16.124 11.525 16.299 11.713L22.587 18H7.99902H8.00002Z" />
	</svg>
);

export default Flag;
